import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=087c1b12&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=ts&"
export * from "./photo.vue?vue&type=script&lang=ts&"
import style0 from "./photo.vue?vue&type=style&index=0&id=087c1b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c1b12",
  null
  
)

component.options.__file = "photo.vue"
export default component.exports